export interface PackageTypeActionTypes {
  type: PackageTypeActions;
  payload?: any;
}

export enum PackageTypeActions {
  CREATE_PARCEL = "CREATE_PARCEL",
  GET_PARCEL_LIST = "GET_PARCEL_LIST",
  SET_PARCEL_LIST = "SET_PARCEL_LIST",
  SET_PARCEL_LIST_PAGE_COUNT = "SET_PARCEL_LIST_PAGE_COUNT",
  GET_PARCEL_DATA_BY_ID = "GET_PARCEL_DATA_BY_ID",
  SET_PARCEL_DATA_BY_ID = "SET_PARCEL_DATA_BY_ID",
  EDIT_PARCEL_DATA_BY_ID = "EDIT_PARCEL_DATA_BY_ID",
}
